module.exports = __webpack_public_path__ + "img/study.397d914.jpg";